module.exports = __webpack_public_path__ + "wf.svg?5e6aa0d6196a1db8431a4fff6937079f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/wf.svg
// module id = 1439
// module chunks = 0